// extracted by mini-css-extract-plugin
export default {"Stat":"styles_Stat__DFZLn","value":"styles_value__l8Dhn","hasData":"styles_hasData__cAmBm","label":"styles_label__hBksW","note":"styles_note__TLT+m"};